import { useContext, createContext } from 'react'
import { reducerInitialState } from '../reducer/pickingAdminReducer'
import { actionTypes } from '../types/actionTypes'
import { ReducerPickingAdminState } from '../types/reducerTypes'

interface PickingAdminContext {
  state: ReducerPickingAdminState
  dispatch: React.Dispatch<actionTypes>
}

// Se crea un Contexto el cual le asignamos el tipo de CountContext el cual tendra nuestro state del reducer y nuestro dispatch
export const PickingAdminContext = createContext<PickingAdminContext>({
  state: reducerInitialState,
  dispatch: () => {}
})

// Se crea un custom hook para validar que nuestro contexto no contenta una instancia indefinida
// y una vez se valide que si contiene una instancia, lo retornamos para su uso posterior

export const usePickingAdmin = () => {
  const context = useContext(PickingAdminContext)
  if (context === undefined) {
    throw new Error('usePickingAdmin must be used within a Provider')
  }

  return context
}
